
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, setDoc} from "firebase/firestore";
import  db from "./firebase";
import { AlertDialog } from "react-onsenui";
import { Button } from "@mui/material";
import { Help} from "@mui/icons-material";


const DB_NAME = 'assignmentDatabase';
const DB_VERSION = 1;
const STORE_NAME = 'assignment store';

function openDatabase(){
  return new Promise((resolve,reject) =>{
   const request = indexedDB.open(DB_NAME,DB_VERSION);
   request.onerror = (event) =>{
    reject(event.target.error);
   };
   request.onupgradeneeded = (event) =>{
    const db = event.target.result;
    db.createObjectStore(STORE_NAME,{keyPath: 'id'});
   };

   request.onsuccess = (event) =>{
    resolve(event.target.result);
   };


  });
}


async function addData(data){
  const db = await openDatabase();
  const transaction = db.transaction(STORE_NAME, 'readwrite');
  const store = transaction.objectStore(STORE_NAME);
  store.put(data);
}


async function getData(key){
  const db = await openDatabase();
  const transaction = db.transaction(STORE_NAME);
  const store = transaction.objectStore(STORE_NAME);
  return new Promise((resolve,reject) =>{
    const request = store.get(key);
    request.onerror = (event) =>{
      reject(event.target.error);
    };
    request.onsuccess = (event) =>{
      resolve(event.target.result);
    };
  });
}

const AssignmentRecord = () => {
   
  const [assignmentYear, setAssignmentYear] = useState('');
  const [email, setEmail] = useState('');
  const [name,setName] = useState('');
  const [country,setCountry] = useState('');
  const [city,setCity] = useState('');
  const [messages,setMessages] = useState('');
  const [soulsWon,setSoulsWon] = useState('');
  const [prayerTime,setPrayerTime] = useState('');
  const [fastingcount,setFastingCount]=useState('');
  const [booksCompleted,setBooksCompleted] = useState('');
  const [bibleBooks,setBibleBooks] = useState('');
  const [otherRecords,setOtherRecords]=useState("");
  const [success,setSuccess] = useState(false);
  const [backuprecord,setbackuprecord] = useState(false);
  const [openHelpDialog, setOpenHelp] = useState(false);

  const navigate = useNavigate();



  const cancelHelpDialog = ()=>{
    setOpenHelp(false);
  };

   const handleSave = async()=>{
    addData({
     id: `year ${assignmentYear}`,
     assignmentYear,
     email,
     name,
     country,
     city,
     messages,
     soulsWon,
     prayerTime,
     fastingcount,
     booksCompleted,
     bibleBooks,
     otherRecords
   }).then(()=>{
    setSuccess(true);
   }).catch((err)=>{
    console.log(err);
   })
   };

   const ViewAllRecords = ()=>{
      navigate("/view_all_records");
   };
   const recoverData=()=>{
    navigate("/contact");
   }

   const CreateStorage = async () =>{
      try{
        await setDoc(doc(db,"Assignment Data Backup",email), {
          id: `year ${assignmentYear}`,
          Assignment: assignmentYear,
          Name: name,
          Country: country,
          City: city,
          Messages: messages,
         Souls_Won: soulsWon,
         Prayer_Time:  prayerTime,
         fastingcount,
         BooksCompleted:  booksCompleted,
          Bible_books: bibleBooks,
          otherRecords
        });
        setbackuprecord(true);
      }catch{
        
      }
   };


  useEffect(()=>{
    getData(`year ${assignmentYear}`).then((data) =>{
       if(data){
        setAssignmentYear(data.assignmentYear);
        setEmail(data.email);
        setName(data.name);
        setCountry(data.country);
        setCity(data.city);
        setMessages(data.messages);
        setSoulsWon(data.soulsWon);
        setPrayerTime(data.prayerTime);
        setFastingCount(data.fastingcount)
        setBooksCompleted(data.booksCompleted);
        setBibleBooks(data.bibleBooks);
        setOtherRecords(data.otherRecords)
       };
    });
  },[assignmentYear]);


    return ( 

        <div className="assignment-record">

            <h3>Assignment DataBase for {assignmentYear}</h3>

            <div className="cmd-buttons">
                <button onClick={handleSave}>Insert/Update Record</button>
                <button onClick={ViewAllRecords}>View Record</button>
                <button onClick={() => CreateStorage(true)}>Backup</button>
                <button onClick={() => setOpenHelp(true)} >Help</button>
                <button onClick={()  =>  recoverData()}>Recover Lost Data</button>
            </div>

            {success && 
                  <div className="toast">
                  <p style={{color:"white",fontWeight:"bold"}}>
                  Assignment Record saved successfully
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setSuccess(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="2em"
                    width="2em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
            }
            {backuprecord &&
              <div className="toast">
              <p style={{color:"white",fontWeight:"bold"}}>
              Backup completed. it is a good practice to backup records
              </p> 
                <svg
                cursor="pointer"
                onClick={()=>setbackuprecord(false)}
                viewBox="0 0 24 24"
                fill="white"
                height="2em"
                width="2em">
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                </svg>
              </div>
            }

       <AlertDialog className="dialog_records"
            isOpen={openHelpDialog}
            onCancel={cancelHelpDialog}>
         <div className="alert-title"><h1 style={{color: "#f1356d"}}> <Help/> Help</h1></div>
         <div className="alert-body">
          <p id="helpText" style={{color: "black", fontWeight: "bold"}}>
              1.Use the <Button>(Insert/Update Record)</Button>  button to temporarily record and keep
            every input you make on the browser. <br/> 2. Use the <Button>(View Record)</Button> to view the list of records you have 
            computed. Note that your records will only be displayed if you have some information stored. <br/>
            3. The <Button>(Backup)</Button> function as the name denotes will backup your records. Your information will be 
            backed up on a secure and safe cloud storage. <br/>
            4. Use the <Button>(Restore Lost Data)</Button> button to recover and restore a lost assignment record which 
            can result due to Phone damage or system failure. To recover and restore your lost record,
            Submit a request on the contact page to recover your lost record. Your name and email address will
              be required for verification. Your lost record will be made available to you after your request 
              is verified and approved. To submit a request, just click on the <Button> (Recover Lost Data) </Button> and you 
              will be redirected to an email client.
          </p> 
         </div>
          <div className="alert-footer">
        </div>
        <Button onClick={cancelHelpDialog}>Ok, Got it</Button>
       </AlertDialog>

            <div className="input-fields-db">
            <div>
            <p>Assignment year</p>
            <input type="text" placeholder="Year of the assignment" value={assignmentYear} onChange={e => setAssignmentYear(e.target.value)}/>
            </div>

            <div>
            <p>Email Address</p>
            <input type="email" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)}/>
            </div>

            <div className="user_name_field">
            <p>Name</p>
            <input type="text" placeholder="enter your name" value={name} onChange={e => setName(e.target.value)}/>
            </div>
          
              <div>
              <p>Country</p> 
            <input type="text" placeholder="Country" value={country} onChange={e => setCountry(e.target.value)}/>
              </div>
        
              <div>
              <p>City/State</p>
            <input type="text" placeholder="City/State/Province" value={city} onChange={e => setCity(e.target.value)}/>
              </div>
          
              <div>
              <p>Number of messages watched</p>
            <input type="text" placeholder="example 20" value={messages} onChange={e => setMessages(e.target.value)}/>
              </div>
        
             <div>
             <p>Number of souls won</p>
            <input type="text" placeholder="example 5" value={soulsWon} onChange={e => setSoulsWon(e.target.value)}/>
             </div>
         
             <div>
             <p>Prayer Time.</p>
            <input type="text" placeholder="example 2 hours 30 mins" value={prayerTime} onChange={e => setPrayerTime(e.target.value)}/>
             </div>
             <div>
             <p>Fasting Count</p>
            <input type="text" placeholder="number of times fasted" value={fastingcount} onChange={e => setFastingCount(e.target.value)}/>
             </div>
            

            <fieldset>
                <legend>List of completed assignment books</legend>
                <textarea placeholder="type completed books here" value={booksCompleted} onChange={e => setBooksCompleted(e.target.value)}/>
            </fieldset>

            <fieldset>
                <legend>List of completed Bible books</legend>
                <textarea placeholder="type the bible books you complete here" value={bibleBooks} onChange={e => setBibleBooks(e.target.value)}/>
            </fieldset>

            <fieldset>
                <legend>All other records</legend>
                <textarea 
                placeholder="keep all other records here. New assignment tasks may be added in any year, try your best to keep those new ones here" 
                value={otherRecords} onChange={e => setOtherRecords(e.target.value)}/>
            </fieldset>

            </div>

        </div>
     );
}
export default AssignmentRecord;